import { render, staticRenderFns } from "./AlertDestinationDeleteScreen.vue?vue&type=template&id=af2dce5a&scoped=true&lang=pug"
import script from "./AlertDestinationDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./AlertDestinationDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./AlertDestinationDeleteScreen.vue?vue&type=style&index=0&id=af2dce5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2dce5a",
  null
  
)

export default component.exports